export const getEnvVariable = (key: string): string => {
  const value = import.meta.env[key] as string | undefined;
  if (value === undefined || value === "") {
    throw new Error(`Missing environment variable: ${key}`);
  }
  return value;
};
